/**
 * @fileoverview Root route configuration combining all feature routes.
 */

import type { RouteObject } from 'react-router';
import App from '../App';
import RootLayout from '../components/RootLayout';
import { PageErrorBoundary, RootErrorBoundary } from '../components';
import { adminRoutes } from './adminRoutes';
import { areasRoutes } from './areasRoutes';
import { authRoutes } from './authRoutes';
import { codeHealthRoutes } from './codeHealthRoutes';
import { dailyReviewRoutes } from './dailyReviewRoutes';
import { dashboardRoutes } from './dashboardRoutes';
import { notesRoutes } from './notesRoutes';
import { weeklyReviewRoutes } from './weeklyReviewRoutes';
import { peopleRoutes } from './peopleRoutes';
import { projectsRoutes } from './projectsRoutes';
import { resourcesRoutes } from './resourcesRoutes';
import { settingsRoutes } from './settingsRoutes';
import { weightRoutes } from './weightRoutes';

export const rootRoutes: RouteObject[] = [
  {
    Component: App,
    errorElement: <RootErrorBoundary />,
    children: [
      {
        path: '/',
        Component: RootLayout,
        errorElement: <PageErrorBoundary />,
        children: [
          ...dashboardRoutes,
          ...notesRoutes,
          ...dailyReviewRoutes,
          ...weeklyReviewRoutes,
          ...weightRoutes,
          ...projectsRoutes,
          ...areasRoutes,
          ...resourcesRoutes,
          ...peopleRoutes,
          ...codeHealthRoutes,
          ...adminRoutes,
          ...settingsRoutes,
        ],
      },
      ...authRoutes,
    ],
  },
];

